import { Component } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
@Component({
  selector: 'app-geo-mapping',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule],
  templateUrl: './geo-mapping.component.html',
  styleUrl: './geo-mapping.component.scss'
})
export class GeoMappingComponent {
  latitude: any = '';
  longitude: any = '';
  IsMocked: number = 0;
  Accuracy: any = '';
  Altitude: any = '';
  Heading: any = '';
  Radius: any = '';

  constructor( 
    private sessionService: SessionService,
    private modalService: NgbModal,
    private toast: ToastService,
  ) { }

  openGoogleMaps() {
    if (this.latitude && this.longitude) {
      const mapsUrl = `https://www.google.com/maps?q=${this.latitude},${this.longitude}`;
      window.open(mapsUrl, '_blank');
    }
    else {
      // this.toast.showMessage('Please Porvide Latitude and Longitude!');
      this.toast.show({ message: 'Please Porvide Latitude and Longitude!', type: toastTypeEnum.warning });
    }
  }
}
